import { render, staticRenderFns } from "./FragmentList.vue?vue&type=template&id=5a6acd48&scoped=true"
import script from "./FragmentList.vue?vue&type=script&lang=js"
export * from "./FragmentList.vue?vue&type=script&lang=js"
import style0 from "./FragmentList.vue?vue&type=style&index=0&id=5a6acd48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6acd48",
  null
  
)

export default component.exports